export const isFiniteNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export const isNumeric = (value: unknown): boolean => {
  if (value === null || value === undefined) return false;
  const numValue = Number(value);
  return Number.isFinite(numValue);
};

/**
 * Formats a number in compact notation (e.g., 1K, 1.5M, 2B)
 * @param value - The number to format
 * @param locale - The locale to use for formatting (default: 'en')
 * @returns Formatted string with compact notation
 */
export const formatCompactNumber = (value: number, locale = 'en'): string => {
  return new Intl.NumberFormat(locale, {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
  }).format(value);
};

// Pseudo random number. See https://stackoverflow.com/a/47593316
const mulberry32 = (seed: number) => {
  let state = seed;

  return (): number => {
    state += 0x6d2b79f5;

    let result = state;
    result = Math.imul(result ^ (result >>> 15), result | 1);
    result ^= result + Math.imul(result ^ (result >>> 7), result | 61);
    result ^= result >>> 14;

    return (result >>> 0) / 4294967296;
  };
};

/**
 * Create a pseudo random number generator from a seed. The seed
 * ensures that the random number generator produces the
 * same sequence of 'random' numbers on every render. It
 * returns a function that generates a random number between
 * a specified min and max.
 */
export const createPseudoRandomNumberGenerator = (seed: number) => {
  const random = mulberry32(seed);
  return (min: number, max: number) => min + (max - min) * random();
};
